<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <h1>
                        {{h1_text}}
                    </h1>

                    <b-form class="form__create" v-if="!show_follow_up_fields" @submit.prevent="onSubmit">
                        <b-form-group>
                            <label>
                                Client
                            </label>

                            <b-form-select 
                                v-model="form.client_id"
                                :options="client_options"
                                class="mb-2">
                                
                                <template slot="first">
                                    <option :value="null" disabled>None</option>
                                </template>
                                
                            </b-form-select>

                            <label>
                                Event Name
                            </label>

                            <b-form-input
                                type="text"
                                v-model="form.name"
                                required>    
                            </b-form-input>

                            <b-form-checkbox class="my-3" v-model="form.requires_payment" switch>
                                Is this a paid event? ({{ form.requires_payment ? "Yes" : "No" }})
                            </b-form-checkbox>

                            <div class="my-3" v-show="form.requires_payment">
                                <label>
                                    Cost
                                </label>

                                <b-form-input
                                    type="number"
                                    v-model="form.cost"
                                    step=0.01
                                    required>    
                                </b-form-input>

                                <b-form-checkbox v-model="form.requires_payment_upfront" switch>
                                    Does this event require payment upfront? ({{ form.requires_payment_upfront ? "Yes" : "No" }})
                                </b-form-checkbox>
                            </div>

                            <label>
                                Description
                            </label>

                            <vue-editor
                                    v-model="form.description"
                                    :editorToolbar="
                                    [
                                        ['bold', 'italic', 'underline'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        ['code-block']
                                  ]"></vue-editor>

                        </b-form-group>

                        <b-form-group>
                            <b-row>
                                <b-col>
                                    <span class="float-left">
                                        <label>
                                            Event image
                                        </label>

                                        <image-picker
                                            :height="image_dimensions.large.height"
                                            :width="image_dimensions.large.width"
                                            @image-picked="(base64) => { form.image_base64 = base64; }">
                                        </image-picker>

                                    </span>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group>
                            <b-row>
                                <b-col>
                                    <address-selector
                                        @changed="addressChanged">
                                    </address-selector>
                                </b-col>
                            </b-row>
                        </b-form-group>
                        
                         <b-button class="mt-3" type="submit" variant="primary" :disabled="ajax_in_progress">
                             <i class="fas fa-circle-notch fa-spin" v-if="ajax_in_progress"></i>
                            Save Event
                        </b-button>
                    </b-form>

                    <div v-if="show_follow_up_fields">

                        <p>Great, the event have been created</p>
                        <p>Add Invite questions and Itinerary items (optional):</p>
                        <h3 class="mb-3">
                            Questions
                        </h3>

                        <editable-question-list 
                            :event-id="event.id"
                            @changed="questions => { this.questions = questions; }">
                        </editable-question-list>

                        <h3>
                            Itinerary
                        </h3>

                        <itinerary-form :event="event"></itinerary-form>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import { VueEditor } from "vue2-editor";
    import ImagePicker from '@/components/ImagePicker.vue';
    import AddressSelector from '@/components/AddressSelector.vue';
    import EditableQuestionList from '@/components/EditableQuestionList.vue';
    import ItineraryForm from '@/components/ItineraryForm.vue';
    import clientRepository from "@/repository/clients";
    import eventRepository from "@/repository/events";

    export default {
        components: {
            ImagePicker,
            AddressSelector,
            EditableQuestionList,
            ItineraryForm,
            VueEditor
        },

        data() {
            return {
                form: {
                    name: "",
                    client_id:"",
                    cost: 0,
                    description: "",
                    small_image: "",
                    large_image: "",
                    venue_name: "",
                    address_address: "",
                    address_lat: "",
                    address_lng: "",
                    town: "",
                    country: "",
                    postal_code: "",
                    lat: "",
                    lng: "",
                    image_base64: "",
                    requires_payment: false,
                    requires_payment_upfront: false
                },
                image_dimensions: {
                    large: {
                        height: 400,
                        width: 800
                    },
                    small: {
                        height: 200,
                        width: 300
                    }
                },
                clients: [],
                client: null,
                questions: [],
                loaded: false,
                errors: {},
                event: null,
                show_follow_up_fields: false,
                ajax_in_progress:false,
            }
        },

        computed: {
            client_options() {
                return this.clients.map((client) => {
                    return {
                        value: client.id,
                        text: client.name
                    }
                });
            },
            h1_text(){
                if(this.show_follow_up_fields){
                    return this.form.name;
                }
                return 'Create a New Event'
            }
        },

        methods: {
            addressChanged(address) {
                this.form.address_address = address.address;
                this.form.address_lat = address.lat;
                this.form.address_lng = address.lng;
            },

            onSubmit() {
                this.form.questions = this.questions;
                this.ajax_in_progress = true;

                eventRepository.store(this.form)
                    .then(response => {
                        this.event = response.data;
                        this.show_follow_up_fields = true;
                        this.ajax_in_progress = false;

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Event Created',
                            text: 'New event successfully created.'
                        });

                        this.clear();

                    }).catch(error => {
                        this.ajax_in_progress = false;
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }else{
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: error.response,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            },

            clear() {
                this.name = "";
                this.client_id = "";
                this.cost = 0;
                this.description = "";
                this.small_image = "";
                this.large_image = "";
                this.venue_name = "";
                this.address_address = "";
                this.address_lat = "";
                this.address_lng = "";
                this.town = "";
                this.country = "";
                this.postal_code = "";
                this.lat = "";
                this.lng = "";
                this.image_base64 = "";
                this.requires_payment = false;
                this.requires_payment_upfront = false;
            }
        },

        mounted() {
            clientRepository.getAll()
                .then(response => {
                    this.clients = response.data;
                    this.loaded = true;
                });
        }
    }
</script>

<style lang="scss">
    .questions {
        .input-group {
            margin-bottom: 10px;
        }

        input {
            margin-bottom: 0!important;
        }
    }
    
    .form__create {
        margin-bottom: 20px;

        &.disabled {
            input, select, textarea, label, .image-preview__info div, .image-preview__close {
                border: none!important;
                pointer-events: none!important;
                padding-left: 0!important;
                background: transparent!important;
            }

            button {
                display: none;
            }
        }
    }
</style>